  //  Link media
  require.context("../media/", true, /^\.\/.*\.*/);
  require.context("../fonts/", true, /^\.\/.*\.*/);

  //  Styles
  import "../styles/styles.scss";

  // JSON
  import { results } from '../data/data.json';

  // JS
  import { mobileAndTabletCheck } from "./proj/utils";

  import Waypoint from "Waypoint";
  import LazyLoad from "./proj/lazyload.js";
  import Tracker from "./proj/Tracker";

  const pkgJson = require("../../package.json");
  const bitlyFromPkg = pkgJson.bitlyUrl;
  const slugFromPkg = pkgJson.slug;

  const isMobileDevice = mobileAndTabletCheck();
  const isMobile = window.innerWidth < 800 || isMobileDevice;

  const tracker = new Tracker(`${slugFromPkg}`);

  const HEADER_CAROUSEL_DELAY = 2500;

  // DETECT SAFARI
  if (
    navigator.userAgent.indexOf("Safari") != -1 &&
    navigator.userAgent.indexOf("Chrome") == -1
  ) {
    //alert('It\'s Safari');
    const theHTML = document.querySelector("html");
    theHTML.classList.add("safari");
  }

  document.addEventListener("DOMContentLoaded", function () {
    $("._trigger-crossfade").hover(
      function () {
        $(this).parents("._hover-parent").addClass("hover");
      },
      function () {
        $(this).parents("._hover-parent").removeClass("hover");
      }
    );
  });

  //lazyload images
  var lazyLoadInstance = new LazyLoad({
    elements_selector: "._lazy",
    callback_error: function () {
      console.log("error");
    },
  });

  /**
   * Project values
   * @desc: Values used to track progress through the quiz
   * 
   */

  let shareText;
  let selections = [];

  /**
   * Method functions
   * @desc: Methods 
   * 
   */

  // SOCIAL: opens social in new  window
  function popupShare(url, title, w, h)
  {
    const left = screen.width / 2 - w / 2;
    const top = screen.height / 2 - h / 2;
    return window.open(url, title, "toolbar=no, menubar=no, scrollbars=yes, resizable=yes, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
  }

  const getResult = () =>
  {
    return selections.filter(val => val == true).length;

    // const keys = {};
    
    // selections.forEach((p_key) =>
    // {
    //   keys[p_key] == undefined
    //     ? keys[p_key] = 1
    //     : keys[p_key] = keys[p_key] + 1;
    // });

    // return Object.keys(keys).map( p_key => ({ id: p_key, value: keys[p_key] }) ).sort((a, b) => a.value > b.value ? -1 : a.value < b.value ? 1 : 0 )[0];
  }

  
  const quizCompleted = e =>
  {
    const score = getResult();
    const questions = [].slice.call(document.querySelectorAll('.questionBlock'));
    const resultObject = results.score.filter(val => score >= parseInt(val.min)).pop();
    const resultElement = document.getElementById('results');

    shareText = results.shareText.replace('{$label}', `${score} out of ${questions.length}`);

    document.getElementById('resultTitle').innerHTML = results.title.replace('{$label}', `${score} out of ${questions.length} correct!`);
    document.getElementById('resultLabel').innerHTML = resultObject.label;

    // document.getElementById('resultTitle').innerHTML = results.title.replace('{$label}', resultObject.label);
    // document.getElementById('resultDescription').innerHTML = resultObject.copy.map(({ value }) => value).join('');

    document.getElementById('resultsImage').src = resultObject.img && (resultObject.img.value && resultObject.img.value.src) || "";
    
    resultElement.classList.add('is-visible');

    // window.scrollTo({top: ((window.scrollY + resultElement.getBoundingClientRect().top) - 50 ), behavior: 'smooth'});


    //tracking quiz completions via Tracker
    tracker.trackMetric(`quiz-complete-${resultObject.id}`);

    //POST call to quiz metrics 
    const apiUrl = 'https://altystg077.execute-api.us-east-1.amazonaws.com/track';
    const quizScore = { "slug": slugFromPkg, "score": score};

    fetch(apiUrl, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(quizScore),
    })
    .then(response => response.json())
    .then(quizScore => {
      console.log('Success!');
    })
    .catch((error) => {
      console.error('Error:', error);
    });


  }

  // QUIZ: check for the correct answer + counter
  const onOptionClicked = e =>
  {
      const { value: { value: selectionValue } } = e.currentTarget.attributes;
      const options = [].slice.call(e.currentTarget.parentElement.children);
      const correctElements = options.filter(el => el.attributes.value.value == 'true');

      const questions = [].slice.call(document.querySelectorAll('.questionBlock'));
      const currentQuestion = questions[selections.length];
      const answerElement = currentQuestion.querySelector('.answerResponse');
      const answerResponseHeading = currentQuestion.querySelector('.answerResponseHeading');
    
      selections.push(selectionValue == 'true');
      
      // Set values
      answerResponseHeading.innerHTML = `${ selectionValue && "Correct. " || "Incorrect. " }`;

      // Set styles
      if(!selectionValue) correctElements.forEach(el => el.classList.add('the-correct-answer'));
      e.currentTarget.classList.add( selectionValue && 'is-correct-answer' || 'is-wrong-answer' );
      currentQuestion.classList.add( selectionValue && 'is-correct' || 'is-incorrect' );
      options.forEach(element => element.classList.add('is-inactive'));
      answerElement.classList.add('is-visible');

      // Advance quiz
      
      const nextQuestionBlock = questions[selections.length];

      // If there's another question, proceed, otherwise process results.
      if(nextQuestionBlock)
      {
        nextQuestionBlock.classList.add('is-ready');
        // window.scrollTo({top: ((window.scrollY + nextQuestionBlock.getBoundingClientRect().top) - (( window.innerHeight - nextQuestionBlock.getBoundingClientRect().height ) / 2) ), behavior: 'smooth'});
      }
      else
      {
        quizCompleted();
      }
  };

  const initHeader = () =>
  {
    let active = 0;
    const images = [].slice.call(document.querySelectorAll('header figure img.crossfade'));
    
    if(images.length > 0)
    {
      setInterval(() =>
      {
        active = (active + 1) % images.length;
        images.forEach((el, idx) => el.classList[active == idx ? 'add' : 'remove']('active'));
      }, HEADER_CAROUSEL_DELAY);

      images[0].classList.add('active');
    }
  }

  const initQuizQuestions = () =>
  {
    
    

    // Initialize question logic.
    [].slice.call(document.querySelectorAll(".questionOption")).forEach( element => element.addEventListener("click", onOptionClicked) );

    // Facebook init
    document.getElementById("facebook").addEventListener('click', e =>
    {
      const bitly = bitlyFromPkg;
      const url = `https://www.facebook.com/share.php?u=${bitly}&quote=${shareText} `;
      const title = "Facebook";
      const w = "500";
      const h = "439";

      popupShare(url, title, w, h);
    });

    // Twitter init
    document.getElementById("twitter").addEventListener('click', e =>
    {
      const bitly = bitlyFromPkg;
      const title = "Twitter";
      const w = "500";
      const h = "439";
      const url = `https://www.twitter.com/share?text=${shareText}&url=${bitly}`;

      popupShare(url, title, w, h);
    });

  }

  /**
   * Init commands
   * 
   */

  initHeader();
  initQuizQuestions();

  // Waypoint recalculations
  document.addEventListener("lazybeforeunveil", function (e) {
    Waypoint.refreshAll();
  });

  document.body.classList.add("start-app");



// WEBPACK FOOTER //
// ./src/js/main.js